export class RuntimeLogger {
    loggers;
    constructor(loggers) {
        this.loggers = loggers;
    }
    log(action) {
        return Promise.allSettled(this.loggers.map((x) => action(x)));
    }
    debug(log, ...rest) {
        return this.log((x) => x.debug(log, ...rest));
    }
    information(log, ...rest) {
        return this.log((x) => x.information(log, ...rest));
    }
    warning(log, ...rest) {
        return this.log((x) => x.warning(log, ...rest));
    }
    error(log, ...rest) {
        return this.log((x) => x.error(log, ...rest));
    }
    critical(log, ...rest) {
        return this.log((x) => x.critical(log, ...rest));
    }
    addLogger(logger) {
        this.loggers.push(logger);
    }
    addLoggers(loggers) {
        this.loggers = this.loggers.concat(loggers);
    }
}
